'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');
var button = require('./button.js');
var icon = require('./icon.js');
var text = require('./text.js');
var motion = require('../theme/motion.js');
require('../utils/scrollLock.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  min-height: 64px;\n  width: 100%;\n  margin-top: auto;\n  padding: 32px;\n  padding-top: 12px;\n  align-items: center;\n  background-color: white;\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  overflow: auto;\n  padding: 16px 32px;\n  flex-grow: 1;\n  background-color: white;\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  min-height: 64px;\n  width: 100%;\n  align-items: center;\n  background-color: white;\n  color: black;\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  opacity: 1;\n  margin: auto;\n  position: relative;\n  animation: ", ";\n  transform-origin: ", ";\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: black;\n  opacity: 0.6;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  z-index: 9;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: transparent;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledModal = styled__default['default'].div(_templateObject(), index.styleEngine);
var ModalBg = styled__default['default'].div(_templateObject2(), index.styleEngine);
var Wrapper = styled__default['default'].div(_templateObject3(), function (props) {
  return props.open ? motion.motionIn : motion.motionOut;
}, function (props) {
  return props.transformOrigin;
}, index.styleEngine({
  height: ['100%', '', 'fit-content'],
  borderRadius: ['0', '', '8px']
}));
var Header = styled__default['default'].div(_templateObject4(), index.styleEngine({
  padding: ['16px', '16px', '16px 32px']
}));
var Content = styled__default['default'].div(_templateObject5(), index.styleEngine);
var Footer = styled__default['default'].div(_templateObject6(), index.styleEngine);
var mousePosition = null;
/**
 * NOTES
 *
 * - Be sure to import motion.less!
 *
 */

var Modal = function Modal(_ref) {
  var propVisible = _ref.visible,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      title = _ref.title,
      showHeader = _ref.showHeader,
      header = _ref.header,
      showFooter = _ref.showFooter,
      footer = _ref.footer,
      onSuccess = _ref.onSuccess,
      successText = _ref.successText,
      onError = _ref.onError,
      errorText = _ref.errorText,
      children = _ref.children,
      wrapperProps = _ref.wrapperProps,
      headerProps = _ref.headerProps,
      contentProps = _ref.contentProps,
      footerProps = _ref.footerProps,
      _ref$modalBGProps = _ref.modalBGProps,
      modalBGProps = _ref$modalBGProps === void 0 ? {} : _ref$modalBGProps,
      _ref$closeButtonProps = _ref.closeButtonProps,
      closeButtonProps = _ref$closeButtonProps === void 0 ? {} : _ref$closeButtonProps,
      restProps = _objectWithoutProperties(_ref, ["visible", "onOpen", "onClose", "title", "showHeader", "header", "showFooter", "footer", "onSuccess", "successText", "onError", "errorText", "children", "wrapperProps", "headerProps", "contentProps", "footerProps", "modalBGProps", "closeButtonProps"]);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var ref = React.useRef();
  /**
   * This will listen for click events to properly
   * set the transform-origin property.
   *
   * @param {*} event
   */

  var clickListener = React.useCallback(function (event) {
    if (ref.current && mousePosition === null) {
      mousePosition = "".concat(event.pageX - ref.current.offsetLeft, "px ").concat(event.pageY - ref.current.offsetTop, "px");
    }
  }, [ref]);
  React.useEffect(function () {
    window.addEventListener('click', clickListener);
    return function () {
      window.removeEventListener('click', clickListener);
    };
  }, []);
  React.useEffect(function () {
    setVisible(propVisible);

    if (propVisible) {
      setOpen(true); // scrollLock(true)
    } else {// scrollLock(false)
      }
  }, [propVisible]);
  var animationProps = React.useMemo(function () {
    return {
      animationName: 'zoom',
      animationDuration: motion.durationSlow,
      transformOrigin: mousePosition // ...customAnimationProps,

    };
  }, [mousePosition]);

  if (!propVisible && !open) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement(StyledModal, wrapperProps, /*#__PURE__*/React__default['default'].createElement(ModalBg, modalBGProps), /*#__PURE__*/React__default['default'].createElement(Wrapper, _extends({}, restProps, animationProps, {
    onAnimationEnd: function onAnimationEnd() {
      if (visible) {
        onOpen && onOpen();
      } else {
        setOpen(false);
        onClose && onClose();
        mousePosition = null;
      }
    },
    open: visible,
    ref: ref
  }), showHeader ? /*#__PURE__*/React__default['default'].createElement(Header, headerProps, header || /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(text['default'], _extends({
    variant: "subtitle"
  }, headerProps === null || headerProps === void 0 ? void 0 : headerProps.titleProps), title), /*#__PURE__*/React__default['default'].createElement(icon['default'], _extends({
    icon: "pyt-close-16",
    cursor: "pointer",
    ml: "auto",
    color: "grey.03",
    position: "absolute",
    top: "20px",
    right: "20px",
    onClick: function onClick() {
      setVisible(false);
      onClose && onClose();
    }
  }, closeButtonProps)))) : null, /*#__PURE__*/React__default['default'].createElement(Content, contentProps, children), showFooter ? /*#__PURE__*/React__default['default'].createElement(Footer, footerProps, footer || /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, onSuccess ? /*#__PURE__*/React__default['default'].createElement(button['default'], {
    variant: "primary",
    padding: "12px 32px",
    onClick: function onClick() {
      return onSuccess();
    }
  }, successText) : null, onError ? /*#__PURE__*/React__default['default'].createElement(text['default'], {
    variant: "secondary",
    color: "primary",
    textTransform: "uppercase",
    textDecoration: "underline",
    fontWeight: "600",
    cursor: "pointer",
    ml: "24px",
    onClick: function onClick() {
      return onError();
    }
  }, errorText) : null)) : null));
};

Modal.propTypes = {
  children: PropTypes__default['default'].node.isRequired,
  title: PropTypes__default['default'].string.isRequired,
  visible: PropTypes__default['default'].bool.isRequired,
  onOpen: PropTypes__default['default'].func,
  onClose: PropTypes__default['default'].func,
  onError: PropTypes__default['default'].func,
  errorText: PropTypes__default['default'].string,
  onSuccess: PropTypes__default['default'].func,
  onClickAway: PropTypes__default['default'].func,
  successText: PropTypes__default['default'].string,
  showFooter: PropTypes__default['default'].bool,
  showHeader: PropTypes__default['default'].bool,
  footer: PropTypes__default['default'].node,
  header: PropTypes__default['default'].node,
  closeOnClickAway: PropTypes__default['default'].bool,
  wrapperProps: PropTypes__default['default'].object,
  headerProps: PropTypes__default['default'].object,
  contentProps: PropTypes__default['default'].object,
  footerProps: PropTypes__default['default'].object,
  customAnimationProps: PropTypes__default['default'].object,
  modalBGProps: PropTypes__default['default'].object,
  closeButtonProps: PropTypes__default['default'].object
};
Modal.defaultProps = {
  errorText: 'Cancel',
  successText: 'Okay',
  showHeader: true,
  showFooter: true
};

exports.default = Modal;
